import React from 'react';
import BottomNav from '../components/BottomNav';

const InsuranceWealthProtection = () => {
  const handleVisitWebsite = () => {
    window.open('https://euroafricawealth.com/', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Euro Africa Insurance</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Tailored insurance, structuring and advisory services for discerning clients at market leading rates</p>
        
        <div className="card">
          <p style={{marginBottom: '1.5rem', lineHeight: '1.6'}}>
            At Euro Africa Wealth, we believe wealth protection and growth deserve more than a standard approach — 
            they deserve personalised attention, independent insight, and world-class partnerships.
          </p>
          
          <p style={{marginBottom: '1.5rem', lineHeight: '1.6'}}>
            As a boutique Financial Services Provider (FSP 52350), EAW specialises in high-value personal insurance 
            and wealth solutions tailored for discerning individuals, professionals, and collectors.
          </p>

          <h3 style={{color: '#CDB688', marginBottom: '1rem', marginTop: '2rem'}}>What Sets Us Apart</h3>
          <p style={{marginBottom: '1.5rem', lineHeight: '1.6'}}>
            EAW combines financial expertise with personal care — ensuring your wealth is not only insured, 
            but intelligently structured for the future.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Vault Content Insurance</h3>
              <p>Specialist cover for luxury assets — jewellery, watches, bullion, art, and collectibles stored in private or IBV vaults</p>
            </div>
            <div className="feature-item">
              <h3>Travel Insurance</h3>
              <p>Comprehensive travel protection for medical, leisure, and business journeys with first-class care anywhere in the world</p>
            </div>
            <div className="feature-item">
              <h3>Mortgage Bond & Risk Cover</h3>
              <p>Combining life, disability, and income protection to ensure your home remains protected through life's uncertainties</p>
            </div>
            <div className="feature-item">
              <h3>Super-Car Insurance</h3>
              <p>Tailored protection for exotic and collector vehicles with agreed-value cover and premium service</p>
            </div>
          </div>

          <div style={{
            marginTop: '2rem',
            padding: '1.5rem',
            background: 'linear-gradient(135deg, #f9f9f9 0%, #ffffff 100%)',
            borderRadius: '8px',
            border: '1px solid rgba(205, 182, 136, 0.2)'
          }}>
            <h3 style={{color: '#CDB688', marginBottom: '0.5rem'}}>Why Choose Us?</h3>
            <ul style={{lineHeight: '1.8', color: '#333'}}>
              <li><strong>Personalised Attention:</strong> Every client is unique. We deliver bespoke cover and advice.</li>
              <li><strong>Independent Advice:</strong> Not tied to any single insurer - we select the best products across multiple leading providers.</li>
              <li><strong>Market Leading Partnerships:</strong> Best-in-class products with concierge-level service.</li>
            </ul>
          </div>

          <button 
            onClick={handleVisitWebsite}
            style={{
              marginTop: '2rem',
              padding: '1rem 2rem',
              background: 'linear-gradient(135deg, #CDB688 0%, #B8A374 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              transition: 'transform 0.2s, box-shadow 0.2s'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(205, 182, 136, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <i className="fas fa-external-link-alt"></i>
            Visit Euro Africa Wealth Website
          </button>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default InsuranceWealthProtection;
